import React from 'react'

export default function NoticiasFiscales() {
    return (
        <div>
            Noticias Fiscales
        </div>
    )
}
